export function logSentryConfig(config: {
  environment: string;
  release?: string;
  serverName: string;
  serviceName: string;
  dsn?: string;
}) {
  // eslint-disable-next-line no-console
  console.info('[sentry]', {
    environment: config.environment,
    release: config.release,
    serverName: config.serverName,
    serviceName: config.serviceName,
    dsnExists: Boolean(config.dsn),
  });
}

export async function flushSentry(Sentry: { flush: (timeout?: number) => Promise<boolean> }, timeout = 5000) {
  const flushOk = await Sentry.flush(timeout);
  // eslint-disable-next-line no-console
  console.info('[sentry] flush complete', { flushOk, timeout });
  return flushOk;
}
